// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file ibc/core/connection/v1/tx.proto (package ibc.core.connection.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { MsgConnectionOpenAck, MsgConnectionOpenAckResponse, MsgConnectionOpenConfirm, MsgConnectionOpenConfirmResponse, MsgConnectionOpenInit, MsgConnectionOpenInitResponse, MsgConnectionOpenTry, MsgConnectionOpenTryResponse, MsgUpdateParams, MsgUpdateParamsResponse } from "./tx_pb.js";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * Msg defines the ibc/connection Msg service.
 *
 * @generated from service ibc.core.connection.v1.Msg
 */
export const Msg = {
    typeName: "ibc.core.connection.v1.Msg",
    methods: {
        /**
         * ConnectionOpenInit defines a rpc handler method for MsgConnectionOpenInit.
         *
         * @generated from rpc ibc.core.connection.v1.Msg.ConnectionOpenInit
         */
        connectionOpenInit: {
            name: "ConnectionOpenInit",
            I: MsgConnectionOpenInit,
            O: MsgConnectionOpenInitResponse,
            kind: MethodKind.Unary,
        },
        /**
         * ConnectionOpenTry defines a rpc handler method for MsgConnectionOpenTry.
         *
         * @generated from rpc ibc.core.connection.v1.Msg.ConnectionOpenTry
         */
        connectionOpenTry: {
            name: "ConnectionOpenTry",
            I: MsgConnectionOpenTry,
            O: MsgConnectionOpenTryResponse,
            kind: MethodKind.Unary,
        },
        /**
         * ConnectionOpenAck defines a rpc handler method for MsgConnectionOpenAck.
         *
         * @generated from rpc ibc.core.connection.v1.Msg.ConnectionOpenAck
         */
        connectionOpenAck: {
            name: "ConnectionOpenAck",
            I: MsgConnectionOpenAck,
            O: MsgConnectionOpenAckResponse,
            kind: MethodKind.Unary,
        },
        /**
         * ConnectionOpenConfirm defines a rpc handler method for
         * MsgConnectionOpenConfirm.
         *
         * @generated from rpc ibc.core.connection.v1.Msg.ConnectionOpenConfirm
         */
        connectionOpenConfirm: {
            name: "ConnectionOpenConfirm",
            I: MsgConnectionOpenConfirm,
            O: MsgConnectionOpenConfirmResponse,
            kind: MethodKind.Unary,
        },
        /**
         * UpdateConnectionParams defines a rpc handler method for
         * MsgUpdateParams.
         *
         * @generated from rpc ibc.core.connection.v1.Msg.UpdateConnectionParams
         */
        updateConnectionParams: {
            name: "UpdateConnectionParams",
            I: MsgUpdateParams,
            O: MsgUpdateParamsResponse,
            kind: MethodKind.Unary,
        },
    }
};
